import { every } from 'lodash';
import { isReferralsAdminAndAbove } from "./checkRoles";
export default function canChangeHoldReason(_ref) {
  var user = _ref.user,
    referral = _ref.referral,
    groupId = _ref.groupId;
  var referralState = referral.state,
    _referral$case = referral.case,
    caseOutcome = _referral$case.outcome,
    caseState = _referral$case.state;
  if (caseState === 'draft') {
    return null;
  }
  var isUserAdminAndAbove = isReferralsAdminAndAbove(user, groupId);
  var isInReviewState = ['in_review'].includes(referralState);
  var isReceivingProvider = referral.receiving_provider.id === groupId;
  var isCaseOutcomeNull = caseOutcome === null;
  return every([isUserAdminAndAbove, isInReviewState, isReceivingProvider, isCaseOutcomeNull]);
}
//# sourceMappingURL=canChangeHoldReason.js.map